import { render, staticRenderFns } from "./UninstallSetScreen.vue?vue&type=template&id=70824ae1"
import script from "./UninstallSetScreen.vue?vue&type=script&lang=js"
export * from "./UninstallSetScreen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports